import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import {IIntroduction} from '../../shared/model/introduction.model';
import {createRequestOption} from "../../shared/util/request-util";
import {SERVER_API_URL} from "../../app.constants";


type EntityResponseType = HttpResponse<IIntroduction>;
type EntityArrayResponseType = HttpResponse<IIntroduction[]>;

@Injectable({ providedIn: 'root' })
export class IntroductionService {
    public resourceUrl = SERVER_API_URL + 'api/introductions';

    constructor(protected http: HttpClient) {}

    create(introduction: IIntroduction): Observable<EntityResponseType> {
        return this.http.post<IIntroduction>(this.resourceUrl, introduction, { observe: 'response' });
    }

    update(introduction: IIntroduction): Observable<EntityResponseType> {
        return this.http.put<IIntroduction>(this.resourceUrl, introduction, { observe: 'response' });
    }

    find(id: number): Observable<EntityResponseType> {
        return this.http.get<IIntroduction>(`${this.resourceUrl}/${id}`, { observe: 'response' });
    }

    query(req?: any): Observable<EntityArrayResponseType> {
        const options = createRequestOption(req);
        return this.http.get<IIntroduction[]>(this.resourceUrl, { params: options, observe: 'response' });
    }

    delete(id: number): Observable<HttpResponse<any>> {
        return this.http.delete<any>(`${this.resourceUrl}/${id}`, { observe: 'response' });
    }
}
